import { gql } from '@apollo/client';
export const COUNTRY = gql `
  query COUNTRY($code: String!) {
    country(code: $code) {
      id
      code
      name
      createdAt
      updatedAt
    }
  }
`;
export const COUNTRY_SCHOOL_STATS = gql `
  query COUNTRY_SCHOOL_STATS($spec: CountrySpec!) {
    countrySchoolStats(spec: $spec) {
      total
      page
      pageSize
      items {
        id
        code
        name
        schoolsCount
      }
    }
  }
`;
export const ACTIVATE_COUNTRY = gql `
  mutation ACTIVATE_COUNTRY($code: String!) {
    activateCountry(code: $code) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
